var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.fixedScroll,
      expression: "fixedScroll"
    }],
    staticClass: "header header--fixed"
  }, [_c('div', {
    staticClass: "header__body"
  }, [_c('v-container', [_c('h1', {
    staticClass: "header__logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/ko",
      "title": "홈으로 이동"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("KIE")])])], 1), _c('div', {
    staticClass: "header__contents"
  }, [_c('div', {
    staticClass: "header__gnb justify-center"
  }, [_c('client-gnb', {
    attrs: {
      "className": "gnb"
    }
  })], 1), _c('div', {
    staticClass: "align-center d-none d-xl-flex header-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/ko/contactus"
    }
  }, [_c('v-btn', {
    staticClass: "color-white font-weight-bold font-size-16 min-w-200px quick-button",
    attrs: {
      "x-large": "",
      "rounded": ""
    }
  }, [_c('span', [_vm._v("Contact US")])])], 1), _c('div', {
    staticClass: "lang-wrap mx-14"
  }, [_c('button', {
    staticClass: "d-block lang-btn pa-2"
  }), _c('ul', {
    staticClass: "lang"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("ENG")])], 1), _c('li', {
    staticClass: "on"
  }, [_vm._v("KOR")])])]), _c('div', {
    staticClass: "hamburger-btn-pc"
  })], 1), _c('div', {
    staticClass: "user-menu--moblie d-flex d-xl-none align-center justify-center"
  }, [_c('router-link', {
    staticClass: "d-block mx-16",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("ENG")]), _c('router-link', {
    attrs: {
      "to": "/ko/contactus"
    }
  }, [_c('v-btn', {
    staticClass: "color-white font-weight-bold font-size-16 px-20 min-w-180px",
    attrs: {
      "x-large": "",
      "rounded": "",
      "color": "primary"
    }
  }, [_c('span', [_vm._v("Contact US")])])], 1)], 1)])])], 1), _vm._m(0), _c('div', {
    staticClass: "side-gnb-wrap"
  }, [_c('v-container', [_c('v-expansion-panels', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('ul', {
    staticClass: "slide-gnb__menu slide-gnb__menu1"
  }, [_c('li', {
    staticClass: "slide-gnb__menu-toggle"
  }, [_c('v-expansion-panel', {
    staticClass: "dep2_li"
  }, [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "slide-gnb__1depth"
  }, [_c('span', [_vm._v("About us")]), _c('div', {
    staticClass: "toggle-icon"
  })])]), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "slid-gnb__sub-ul"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/aboutus/company-profile"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("회사 프로필")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/aboutus/certificate"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("인증서")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/aboutus/organization"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("조직도")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/aboutus/location/paju"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("위치")])], 1)])])], 1)], 1), _c('li', [_c('v-expansion-panel', {
    staticClass: "dep2_li"
  }, [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "slide-gnb__1depth"
  }, [_c('span', [_vm._v("Product")]), _c('div', {
    staticClass: "toggle-icon"
  })])]), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "slid-gnb__sub-ul"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/product/Analyzer"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("분석기 시스템")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/product/CEMS"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("CEMS / AQMS")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/product/Liquid"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("액체 분석기 시스템")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/product/Sampling"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("샘플링 시스템")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/product/Corrosion"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("부식 모니터링 시스템")])], 1)])])], 1)], 1), _c('li', [_c('v-expansion-panel', {
    staticClass: "dep2_li"
  }, [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "slide-gnb__1depth"
  }, [_c('span', [_vm._v("Project / Reference")]), _c('div', {
    staticClass: "toggle-icon"
  })])]), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "slid-gnb__sub-ul"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/project"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("Project")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/reference"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("Reference")])], 1)])])], 1)], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('ul', {
    staticClass: "slide-gnb__menu slide-gnb__menu2"
  }, [_c('li', {
    staticClass: "slide-gnb__menu-toggle"
  }, [_c('v-expansion-panel', {
    staticClass: "dep2_li"
  }, [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "slide-gnb__1depth"
  }, [_c('span', [_vm._v("Alliance")]), _c('div', {
    staticClass: "toggle-icon"
  })])]), _c('v-expansion-panel-content', [_c('ul', {
    staticClass: "slid-gnb__sub-ul"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/alliance/#abb"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("ABB")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/alliance/#teledyne"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("TELEDYNE")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/alliance/#pac"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("PAC")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/alliance/#metal"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("Metal Samples")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ko/alliance/#extrel"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("EXTREL")])], 1)])])], 1)], 1), _c('li', [_c('router-link', {
    staticClass: "slide-gnb__1depth",
    attrs: {
      "to": "/ko/contactus"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.slidGnbSubLinkClick($event);
      }
    }
  }, [_vm._v("Contact US")])], 1)])])], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hamburger-btn"
  }, [_c('span')]);
}]

export { render, staticRenderFns }